var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgK8SHorizontalPodAutoscaler = function SvgK8SHorizontalPodAutoscaler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2h10a1 1 0 0 1 1 1v7h-1V3H3v7H2V3a1 1 0 0 1 1-1M4 11l-2 2 2 2 .705-.705-.79-.795h8.17l-.79.795L12 15l2-2-2-2-.705.705.79.795h-8.17l.79-.795z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
export default SvgK8SHorizontalPodAutoscaler;